import React, { useContext, useState } from 'react'
import {
  Button,
  TextField,
  Box,
  Card,
  CardContent,
  IconButton,
  InputAdornment
} from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { AccountContext } from 'contexts/AccountContext'

type FormData = {
  email: string
  password: string
}

const LoginPage = () => {
  const { login } = useContext(AccountContext)
  const navigate = useNavigate()

  const { register, handleSubmit } = useForm<FormData>()

  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword(prev => !prev)

  const onSubmit = async (data: FormData) => {
    await login(data.email, data.password)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default'
      }}
    >
      <Card
        sx={{
          padding: '20px',
          width: '90%',
          maxWidth: 500,
          mx: 2,
          borderRadius: '12px',
          boxShadow: '0px 8px 20px #d9d9d9',
          overflow: 'hidden'
        }}
      >
        <CardContent>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box
              component='img'
              src='/woodland-logo-dark-horizontal.png'
              alt='logo'
              sx={{
                mb: '20px',
                width: '260px',
                maxWidth: '100%',
                height: 'auto'
              }}
            />
          </Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              label='Email'
              fullWidth
              margin='normal'
              {...register('email')}
              inputProps={{ maxLength: 50 }}
              InputLabelProps={{ shrink: true }}
              sx={{
                mb: 2,
                '& .MuiInputBase-input': { color: 'black' },
                '& .MuiInputLabel-root': { color: 'primary.main' }
              }}
            />

            <TextField
              label='Password'
              type={showPassword ? 'text' : 'password'}
              fullWidth
              margin='normal'
              {...register('password')}
              inputProps={{ maxLength: 64 }}
              InputLabelProps={{ shrink: true }}
              sx={{
                mb: 2,
                '& .MuiInputBase-input': { color: 'black' },
                '& .MuiInputLabel-root': { color: 'primary.main' }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={handleClickShowPassword}
                      edge='end'
                      aria-label='toggle password visibility'
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <Box sx={{ textAlign: 'left', mb: 2 }}>
              <Button
                variant='text'
                onClick={() => navigate('/password-reset')}
                sx={{
                  color: 'primary.main',
                  fontWeight: 'bold'
                }}
              >
                Forgot Password?
              </Button>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <Button type='submit' fullWidth variant='contained'>
                Login
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  )
}

export default LoginPage
